<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row class="pb-1">
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.equipments') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="equipmentsTable.additionalFilters"
									:default-sort="equipmentsTable.defaultSort"
									:excel="true"
									:fields="equipmentsTable.headers"
									:header-selection-key="'equipments-headers'"
									:height="equipmentsTable.height"
									:total-records="equipmentsTable.total"
									:filter-save-key="'equipments-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in equipmentsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="equipmentsTable.selectedHeaders.includes('id')"
											@click="editClick(item.id, false)"
										>
											{{ item.id }}
										</td>
										<td
											v-if="equipmentsTable.selectedHeaders.includes('name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.name }}</b>
										</td>
										<td
											v-if="equipmentsTable.selectedHeaders.includes('equipment_type_id')"
											@click="editClick(item.id, false)"
										>
											{{ item.equipment_type.name }}
										</td>
										<td
											v-if="equipmentsTable.selectedHeaders.includes('classroom_id')"
											@click="editClick(item.id, false)"
										>
											{{ item.classroom != null ? item.classroom.name : 'Nedodjeljeno' }}
										</td>
										<td
											v-if="equipmentsTable.selectedHeaders.includes('entry_date')"
											@click="editClick(item.id, false)"
										>
											{{
												item.entry_date != null
													? item.entry_date.split('-').reverse().join('.')
													: ''
											}}
										</td>
										<td
											v-if="equipmentsTable.selectedHeaders.includes('inspection_date')"
											@click="editClick(item.id, false)"
											:class="{ 'red-text': isDateInPast(item.inspection_date) }"
										>
											{{
												item.inspection_date != null
													? item.inspection_date.split('-').reverse().join('.')
													: ''
											}}
										</td>
										<td
											v-if="equipmentsTable.selectedHeaders.includes('write_off')"
											@click="editClick(item.id, false)"
										>
											<v-icon v-if="item.write_off" small>fa-check</v-icon>
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Equipments',
	components: { TheTable },
	data: function () {
		return {
			equipmentsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.id'), value: 'id', type: 'string', width: '60px', allowFilter: true },
					{ text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.type'),
						value: 'equipment_type_id',
						type: 'dropdown|equipment-types',
						allowFilter: true,
					},
					{
						text: this.$t('fields.classroom'),
						value: 'classroom_id',
						type: 'dropdown|classrooms-with-null',
						allowFilter: true,
					},
					{ text: this.$t('fields.entryDate'), value: 'entry_date', type: '', allowFilter: true },
					{
						text: this.$t('fields.incomingInspection'),
						value: 'inspection_date',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.writtenOff'),
						value: 'write_off',
						type: 'boolean',
						width: '100px',
						allowFilter: false,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [{ text: this.$t('fields.entryDate'), value: 'entry_date', type: 'date_range' }],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'name',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/equipments/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/equipments/' + id);
			} else {
				let routeData = this.$router.resolve('/equipments/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.equipmentsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.equipmentsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'equipments',
				request,
				(data, success) => {
					if (success) {
						vm.equipmentsTable.items = data.items;
						vm.equipmentsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		isDateInPast(date) {
			const inspectionDate = new Date(date);
			const today = new Date();
			return inspectionDate < today;
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.equipmentsTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'equipments',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/equipments', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.equipmentsTable.height = window.innerHeight - 243 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.equipments'), href: '/#/equipments', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped>
.red-text {
	color: red;
}
</style>
